import { forwardRef, MouseEvent, ReactElement, Ref } from "react";
import { Button } from "@twilio-paste/core/button";

import { types } from "./definitions";

const TrackingButton = forwardRef(
  (
    { children, onClick, trackEvent, ...rest }: types.TrackingButtonProps,
    ref: Ref<HTMLButtonElement>
  ): ReactElement => {
    const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
      if (trackEvent) {
        trackEvent();
      }
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <Button onClick={handleClick} ref={ref} {...rest}>
        {children}
      </Button>
    );
  }
);

export default TrackingButton;
